<template>
	<div>
		<titulo-rematricula />
		<b-tabs v-model="activeTab">
			<b-tab class="pt-3" :title="`1 - ${$t('ACADEMICO.DADOS_GERAIS')}`">
				<b-row class="mt-2">
					<b-col class="col-12">
						<dados-gerais :dados="matricula" />
					</b-col>
					<b-col class="col-12 mt-4">
						<responsaveis :responsaveis="matricula.vinculos" />
					</b-col>
					<b-col class="col-12 mt-4">
						<contatos :contatos="matricula.contatos" />
					</b-col>
					<div class="col-12 mt-4">
						<endereco :enderecos="matricula.enderecos" />
					</div>
				</b-row>
				<b-row>
					<b-col class="mt-3 col-12 d-flex justify-content-end">
						<router-link to="/protocolo">
							<b-button
								class="mr-0 mr-md-3"
								variant="secondary"
								>{{ $t("MATRICULAS.REPORTAR_ERRO") }}</b-button
							>
						</router-link>
						<b-button @click="activeTab++" variant="primary"
							>Próximo</b-button
						>
					</b-col>
				</b-row>
			</b-tab>

			<b-tab
				v-if="!ehIntegral"
				class="pt-3"
				:title="`2 - ${$t('ACADEMICO.DADOS_DE_SAUDE')}`"
			>
				<span class="btn-outline-danger d-block mb-4">
					{{ $t("ACADEMICO.CONFIRMAR_DADOS_DE_SAUDE") }}
				</span>
				<ficha-saude
					@ficha-saude="getFichaSaude"
					@confirmar="confirmacaoFichaSaude"
				/>
				<b-row>
					<b-col class="mt-3 col-12 d-flex justify-content-end">
						<router-link to="/protocolo">
							<b-button
								class="mr-0 mr-md-3"
								variant="secondary"
								>{{ $t("MATRICULAS.REPORTAR_ERRO") }}</b-button
							>
						</router-link>
						<b-button
							@click="activeTab++"
							:disabled="desabilitar.tabRematricula"
							variant="primary"
							>Próximo</b-button
						>
					</b-col>
				</b-row>
			</b-tab>

			<b-tab
				:disabled="desabilitar.tabRematricula"
				class="pt-3"
				:title="`${ehIntegral ? 2 : 3} - ${$t('ACADEMICO.TERMOS')}`"
			>
				<b-row class="mt-2">
					<b-col class="col-12 mt-4">
						<extra-classe v-if="!ehIntegral" />
					</b-col>
					<b-col class="col-12 mt-4">
						<aceitar-termos
							@baixa-contrato="baixarContrato"
							@aceitar="aceitarTermos"
						/>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="col-12 mt-4">
						<b-alert variant="primary" show>
							<strong>{{ $t('ACADEMICO.AVISO_PERIODO_MATRICULA', { ano: anoMatriculaAtual }) }}</strong>
						</b-alert>
					</b-col>
					<b-col class="mt-3 col-12 d-flex justify-content-end">
						<router-link to="/protocolo">
							<b-button
								class="mr-0 mr-md-3"
								variant="secondary"
								>{{ $t("MATRICULAS.REPORTAR_ERRO") }}</b-button
							>
						</router-link>
						<b-button
							@click="confirmarRematricula"
							:disabled="btnFazerRematricula"
							variant="primary"
							>{{ $t("MATRICULAS.FAZER_REMATRICULA") }}</b-button
						>
					</b-col>
				</b-row>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import ContratoService from "@/common/services/contratos/contratos.service.js";
import rotas from "@/common/utils/rotas";
import pdf from "@/common/utils/pdf";
import mensagem from "@/common/utils/mensagem";

// services
import FichaSaudeService from "@/common/services/ficha-saude/ficha-saude.service";
import MatriculaService from "@/common/services/matricula/matricula.service";
// import PessoaService from "@/common/services/pessoa/pessoa.service";

// import breadcrumb from "@/common/utils/breadcrumb"

// import BaseCard from '@/components/card/BaseCard.vue';
import TituloRematricula from "./components/TituloRematricula";
import DadosGerais from "@/views/academico/matriculas/components/DadosGerais";
import Responsaveis from "@/views/academico/matriculas/components/Responsaveis";
import Contatos from "@/views/academico/matriculas/components/Contatos";
import Endereco from "@/views/academico/matriculas/components/Endereco";
import FichaSaude from "./components/fichaSaude/Index";
import AceitarTermos from "./components/AceitarTermos";
import ExtraClasse from "./components/ExtraClasse";

const FICHA_SAUDE_PADRAO = {
	planoDeSaude: "",
	numeroCarteirinha: "",
	diabetes: false,
	medicamentoContinuo: false,
	nomeMedicamento: "",
	motivoMedicamento: "",
	alergia: false,
	especificaoAlergia: "",
	intoleranciaLactose: false,
	intoleranciaGluten: false,
	refluxo: false,
	deficiencia: false,
	especificacaoDeficiencia: "",
	tiposDeficiencias: [],
	observacoes: "",
	contratoId: "",
};

export default {
	components: {
		TituloRematricula,
		DadosGerais,
		Endereco,
		Responsaveis,
		Contatos,
		FichaSaude,
		AceitarTermos,
		ExtraClasse,
	},
	data() {
		return {
			matricula: [],
			contratoMatriculaId: "",
			fichaSaude: [],
      activeTab: 0,
			desabilitar: {
				btnFazerRematricula: true,
				tabRematricula: true,
			},
		};
	},
	async mounted() {
		await this.getDados();
	},
	computed: {
		btnFazerRematricula() {
			return this.desabilitar.btnFazerRematricula;
		},
		ehIntegral() {
			return this.matricula.tipoContrato === 525;
		},
		anoMatriculaAtual() {
			// A rematrícula é para o próximo ano letivo; o aviso fala do ano em que o aluno está matriculado hoje
			const anoRematricula = Number(this.matricula.anoLetivo);
			return anoRematricula ? anoRematricula - 1 : new Date().getFullYear();
		},
	},
	methods: {
		async getDados() {
			this.$store.state.matriculas.matriculas.forEach((element) => {
				if (element.contratoId == this.$route.params.contratoId) {
					this.matricula = element;
				}
			});

			if (!Object.keys(this.matricula).length) {
				try {
					this.$store.dispatch(START_LOADING);
					const data = await MatriculaService.getTodasMatriculasUserLogadoAndStore();
					const matriculaEncontrada = data.find(element => element.contratoId == this.$route.params.contratoId);
					if (matriculaEncontrada) {
						this.matricula = matriculaEncontrada;
					}
				} catch (error) {
					console.error('Erro ao buscar dados da matrícula:', error);
					return mensagem.erro(
						"Ooops!",
						"Não foi possível puxar os dados desta matrícula no momento, aguarde ou contate o suporte"
					);
				} finally {
					this.$store.dispatch(STOP_LOADING);
				}
			}

			if (!Object.keys(this.matricula).length) {
				return mensagem.erro(
					"Ooops!",
					"Não foi possível puxar os dados desta matrícula no momento, aguarde ou contate o suporte"
				);
			}

			this.obterContratoId();

			if (this.ehIntegral) this.desabilitar.tabRematricula = false;

			this.matricula.enderecos.forEach((element) => {
				element.principal == true
					? (element.principalTexto = "Sim")
					: (element.principalTexto = "Não");
			});
		},
		getFichaSaude(fichaSaude) {
			if (fichaSaude) {
				this.fichaSaude = fichaSaude;
			} else {
				this.fichaSaude = { ...FICHA_SAUDE_PADRAO };
			}
		},
		async baixarContrato() {
			try {
				this.$store.dispatch(START_LOADING);

				const contratoId = this.$route.params.contratoId;

				if (contratoId) {
					const { data } = await ContratoService.baixarPDF(contratoId);

					if (data.documento) {
						const bytes = pdf.base64ToArrayBuffer(data.documento);
						const blob = new Blob([bytes], {
							type: "application/pdf",
						});

						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = data.nomeArquivo;
						link.click();
					}
				}
			} catch (err) {
				mensagem.showErrors(err);
			} finally {
				this.$store.dispatch(STOP_LOADING);
			}
		},
		obterContratoId() {
			this.contratoMatriculaId = this.$route.params.contratoId;
		},
		async confirmarRematricula() {
			try {
				this.$store.dispatch(START_LOADING);
				// Rematrícula do contrato
				const { data } = await ContratoService.ativarContrato(
					this.$route.params.contratoId,
					true
				);

				if (data.id && !this.ehIntegral) {
					const fichaSaudeParaEnviar = this.fichaSaude || { ...FICHA_SAUDE_PADRAO };

					await FichaSaudeService.atualizarFicha({
						...fichaSaudeParaEnviar,
						contratoId: data.id,
					});
				}
			
				this.$store.dispatch(STOP_LOADING);
				await mensagem.sucesso("Rematrícula efetuada!");
				rotas.retornar();
			} catch (err) {
				mensagem.showErrors(err);
			} finally {
				this.$store.dispatch(STOP_LOADING);
			}
		},
		confirmacaoFichaSaude(checkboxValue) {
			this.desabilitar.tabRematricula = !checkboxValue;
		},
		aceitarTermos(checkboxValue) {
			this.desabilitar.btnFazerRematricula = !checkboxValue;
		},
	},
};
</script>

<style>
#rematriculaPrevBtn {
	display: none;
}
</style>
